const { h, render, Component } = require('preact');

class Date extends Component {
  constructor(props) {
    super(props);
    this.changeDateState = this.changeDateState.bind(this)
    this.readInput = this.readInput.bind(this)
    this.validateInput = this.validateInput.bind(this)
  }

  changeDateState() {
    this.props.updateState(this.props.attrs.type, this.props.attrs.counter, this.populateInput(), this.validateInput())
  }

  getDateInputHtmlElement() {
    var elementId = "v1-date" + this.props.attrs.counter
    return document.getElementById(elementId)
  }

  readInput() {
    var date = {}
    var dateElement = this.getDateInputHtmlElement()
    if (dateElement) {
      date = dateElement.value
    }
    return date
  }

  validateInput() {
    if (this.props.attrs.required  == "true") {
      return this.getDateInputHtmlElement().value.trim().length > 0
    }
    return true
  }

  populateInput() {
    var data = {}
    var inputData = this.readInput()
    data.description = `\n\n ${this.props.attrs.label} : ${inputData}`;
    return data
  }

  componentDidMount() {
    var dateElement = this.getDateInputHtmlElement()
    if (dateElement) {
      dateElement.addEventListener("change", this.changeDateState)
    }
  }

  render() {
    let attrs = this.props.attrs
    return (
      <div>
        <label><strong>{attrs.label}
          {attrs.required == "true" ? (<span class="mandatory-field"> * </span>) : null}
        </strong></label>
        <input class="date-time-input" type="date" data-bhw={'date_input' + attrs.counter} id={"v1-date" + attrs.counter} aria-label={attrs.label}/>
      </div>
    )
  }
}

module.exports = Date
